import React from 'react';
import { CheckIcon } from 'lucide-react';
import { systemPills } from '../data/content';
export function SystemSection() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-14" data-id="element-188" data-mp="3gihpbm3cc2sl">
      <div className="mx-auto max-w-[1000px] text-center" data-id="element-189" data-mp="3bhtzv4urfu0h">
        <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2.1rem]" data-id="element-190" data-mp="36jshyn92m0ql">
          The Complete 6-in-1 Financial Literacy Teaching System
        </h2>

        <p className="mt-3 text-[0.8rem] font-bold uppercase tracking-[0.22em] text-orange-500 sm:text-[0.9rem]" data-id="element-191" data-mp="2wu0knl9l6tif">
          Plan • Teach • Assess • Track
        </p>

        <ul className="mx-auto mt-6 grid max-w-[720px] gap-3 text-left sm:grid-cols-2" data-id="element-192" data-mp="2ssnbb17ac86r">
          {systemPills.map(pill => <li key={pill} className="flex items-center gap-3 rounded-md bg-slate-900 px-5 py-3 text-[1rem] text-white" data-id="element-193" data-mp="2iu7ubr1z2faz">
              <CheckIcon className="h-4 w-4 shrink-0 text-orange-500" strokeWidth={2.5} aria-hidden="true" data-id="element-194" data-mp="2dvwmtmz5ggvx" />
              {pill}
            </li>)}
        </ul>
      </div>
    </section>;
}